import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Button from '@zenbusiness/common-components/Button';

import Box from '@mui/material/Box';

import Section from './components/Section';

import { StyledImage } from './styles';
import { MT_DATA_TRACKING, MEET_WITH_EXPERTS_REGISTRATION_URL } from './utils/constants';

const imageSrc = 'https://res.cloudinary.com/zenbusiness/q_auto/v1/shared-assets/s2/vector/office-hours-registration.svg';

const MeetWithExperts = () => {
  const handleRegistrationClick = useLinkPressedCallback({
    ...MT_DATA_TRACKING,
    elementName: 'register_zoom',
    linkDestination: MEET_WITH_EXPERTS_REGISTRATION_URL,
    elementAsset: imageSrc
  });

  return (
    <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={{ xs: 2, md: 10 }} justifyContent="center" alignItems="center">
      <Section
        title="Website Builder Office Hours"
        description="See the website builder in action and get your questions answered."
        id="website_builder"
        hasExpertsPill
      >
        <Button fullWidth={false} variant="primary" size="small" onClick={handleRegistrationClick} href={MEET_WITH_EXPERTS_REGISTRATION_URL}>
          <Box component="span" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
            Register
          </Box>
        </Button>
      </Section>
      <a onClick={handleRegistrationClick} href={MEET_WITH_EXPERTS_REGISTRATION_URL} rel="noopener noreferrer">
        <StyledImage component="img" image={imageSrc} />
      </a>
    </Box>
  );
};

export default MeetWithExperts;
